(function ($) {
    $(document).ready(() => {
        const queryParamsElements = $("div[data-query-params]").get();

        for (const queryParamsElement of queryParamsElements) {
            if (!queryParamsElement) return;
            const listId = $(queryParamsElement).attr("data-grid-wrapper-id");
            if (!listId) return;

            const tableContentElement = $(queryParamsElement).attr("data-grid-id");

            /* ========================= Info boxes ================================= */
            $(`#${listId} [data-info-id]`).hover(
                function () {
                    const infoId = $(this).attr("data-info-id");
                    const infoTitle = $(this).attr("data-info-title");
                    const infoContent = $(this).attr("data-info-content");
                    const y =
                        $(`[data-info-id="${infoId}"]`).offset().top -
                        $(window).scrollTop() -
                        $('[data-info-box="true"]').height() -
                        20;
                    const x =
                        $(`[data-info-id="${infoId}"]`).offset().left -
                        $(window).scrollLeft() -
                        $('[data-info-box="true"]').width() -
                        20;

                    $('[data-info-box-title="true"]').text(infoTitle);
                    $('[data-info-box-content="true"]').text(infoContent);
                    $('[data-info-box="true"]').css("display", "block").css("top", `${y}px`);
                    $('[data-info-box="true"]').css("display", "block").css("left", `${x}px`);
                },
                () => {
                    $('[data-info-box="true"]').css("display", "none");
                }
            );

            /* ======================= Scroll theme columns together ================== */
            function linkThemeColumnsScroll() {
                let isSyncingScroll = false;

                $(`#${listId} .scroll-columns`).on("scroll", function (event) {
                    if (isSyncingScroll) return;

                    isSyncingScroll = true;
                    const scrollLeft = this.scrollLeft;

                    $(`#${listId} .scroll-columns`).each(function () {
                        if (this !== event.target) {
                            this.scrollLeft = scrollLeft;
                        }
                    });

                    // Use a timeout to reset the syncing flag after the frame
                    requestAnimationFrame(() => {
                        isSyncingScroll = false;
                    });
                });
            }

            linkThemeColumnsScroll();

            $(`#${tableContentElement}`)?.on("remove", (ev) => {
                setInterval(() => {
                    linkThemeColumnsScroll();
                }, 500);
            });

            /* ======================= Scroll theme columns with arrow ================== */
            function initTableScrollControls() {
                const scrollableRows = $(`#${listId} .scroll-columns`);
                const leftButton = $('button[data-table-arrow="left"]');
                const rightButton = $('button[data-table-arrow="right"]');
                const scrollAmount = 300; // Customize the amount you scroll per click

                function updateArrowState() {
                    const firstScrollable = scrollableRows.get(0);
                    const scrollLeft = firstScrollable.scrollLeft;
                    const maxScrollLeft = firstScrollable.scrollWidth - firstScrollable.clientWidth;

                    leftButton.prop("disabled", scrollLeft <= 0);
                    rightButton.prop("disabled", scrollLeft >= maxScrollLeft - 1); // slight offset to avoid float rounding issues
                }

                function scrollAll(delta) {
                    scrollableRows.each(function () {
                        this.scrollTo({ left: this.scrollLeft + delta, behavior: "smooth" });
                    });

                    // Small delay to ensure scrollLeft is updated before checking
                    setTimeout(updateArrowState, 10);
                }

                leftButton.on("click", () => scrollAll(-scrollAmount));
                rightButton.on("click", () => scrollAll(scrollAmount));

                // Also update button state on manual scroll
                scrollableRows.on("scroll", updateArrowState);
            }

            initTableScrollControls();
        }
    });
})(jQuery);
